import { render, staticRenderFns } from "./BaseBlockChecklist.vue?vue&type=template&id=6e79eab2&scoped=true&lang=pug&"
import script from "./BaseBlockChecklist.vue?vue&type=script&lang=js&"
export * from "./BaseBlockChecklist.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockChecklist.vue?vue&type=style&index=0&id=6e79eab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79eab2",
  null
  
)

export default component.exports